if(typeof reviewsSlider !== 'function'){
    class reviewsSlider extends HTMLElement{
        constructor(){
            super();  
            this.reviewsGallery = this.querySelector('[data-review]') ;
            this.waitForSlick();
        }   

        waitForSlick(){
             const checkSlick = setInterval(() => {
                if (window.jQuery && typeof jQuery.fn.slick !== 'undefined') {
                    clearInterval(checkSlick); 
                    this.initSlick(); 
                }
            }, 100);
        }
        initSlick(){
              if (!this.reviewsGallery) return;
               jQuery(this.reviewsGallery).slick({
                dots: true,              
                arrows: true,           
                fade: false,             
                infinite: true,          
                slidesToShow: 3,         
                slidesToScroll: 1,       
                speed: 500,              
                autoplay: true,          
                autoplaySpeed: 5000,    
                pauseOnHover: true,
                responsive: [
                    {
                        breakpoint: 480,  
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1,
                            centerMode: true,
                            centerPadding: '20px'
                        }
                    },
                    {
                        breakpoint: 768,  
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 1,

                        }
                    },
                    {
                        breakpoint: 1024, 
                        settings: {
                            slidesToShow: 3,
                            slidesToScroll: 1,
                        }
                    }
                ]
               });
        }
    }

      if (typeof customElements.get('reviews-slider') === 'undefined') {
        customElements.define('reviews-slider', reviewsSlider);
    }
}